import React from 'react';

const LazyImage = ({ image, childCss, ...rest }) => {
    if (!image) return null;

    return <img
        className={`${childCss} lazyload`}
        key={image}
        alt=""
        data-srcset={image}
        data-sizes="auto"
        {...rest}
    />;
};

LazyImage.defaultProps = {
    childCss: ''
};

export default LazyImage;
